

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerWizardModule, FieldComparison, FieldChoice, KeepDeleteChoice, PositionMergeComparison, PositionFieldChoices, SkillMergeComparison, QualificationMergeComparison } from '@/store/modules/workerWizard';
import CurrencyUtils from '@/lib/currencyUtils';
import IconConstants from '@/lib/iconConstants';

@Component({
  name: 'WorkerWizardMergeReview'
})
export default class WorkerWizardMergeReview extends Vue {
  IconConstants = IconConstants;

  // Summary dialog state
  summaryDialog = false;
  summaryDialogTitle = '';
  summaryDialogContent = '';

  showSummaryDialog(content: string, title: string) {
    this.summaryDialogContent = content;
    this.summaryDialogTitle = `Summary - ${title}`;
    this.summaryDialog = true;
  }

  get existingWorkerName(): string {
    const match = WorkerWizardModule.selectedDuplicateMatch;
    if (!match) return '';
    const worker = match.worker as any;
    const firstName = worker.person ? worker.person.firstName : '';
    const lastName = worker.person ? worker.person.lastName : '';
    return `${firstName} ${lastName}`.trim() || 'Unknown';
  }

  get existingWorkerRef(): string {
    const match = WorkerWizardModule.selectedDuplicateMatch;
    return match ? match.worker.sequenceNumber : '';
  }

  get matchTypeDisplay(): string {
    const match = WorkerWizardModule.selectedDuplicateMatch;
    if (!match) return '';
    if (match.emailMatch) return 'Email Match';
    if (match.nameMatch) return 'Name Match';
    return 'Potential Match';
  }

  get matchTypeColor(): string {
    const match = WorkerWizardModule.selectedDuplicateMatch;
    if (!match) return 'grey';
    if (match.emailMatch) return 'warning';
    if (match.nameMatch) return 'success';
    return 'grey';
  }

  // Get all field comparisons from store
  get allFieldComparisons(): FieldComparison[] {
    return WorkerWizardModule.fieldComparisons;
  }

  // Section-based field getters
  get summaryFields(): FieldComparison[] {
    const fields = ['summary', 'biography'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  get personalFields(): FieldComparison[] {
    const fields = ['firstName', 'lastName', 'gender', 'nationality', 'dateOfBirth', 'maritalStatus', 'nationalInsuranceNumber'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  get contactFields(): FieldComparison[] {
    const fields = ['emailAddress', 'mobilePhoneNumber', 'otherPhoneNumber'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  get nextOfKinFields(): FieldComparison[] {
    const fields = ['emergencyContactName', 'emergencyContactPhoneNumber'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  get addressFields(): FieldComparison[] {
    const fields = ['buildingNameNumber', 'streetRoadBlock', 'locality', 'cityTown', 'stateProvinceRegion', 'postZipCode', 'countryCode', 'geometry', 'isExactGeo'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  get workSettingsFields(): FieldComparison[] {
    const fields = ['workTypes', 'defaultBranchId', 'defaultDeskId', 'payrollNumber', 'availabilityRestriction'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  get otherFields(): FieldComparison[] {
    const fields = ['isDriver', 'maximumPassengers', 'isAgreedToMarketing', 'isUnspentConvictions', 'convictionDetails'];
    return this.allFieldComparisons.filter(f => fields.includes(f.field));
  }

  // Count differences in a section
  getSectionDifferenceCount(fields: FieldComparison[]): number {
    return fields.filter(f => f.isDifferent).length;
  }

  get fieldsWithDifferences(): FieldComparison[] {
    return WorkerWizardModule.fieldsWithDifferences;
  }

  get identicalFields(): FieldComparison[] {
    return WorkerWizardModule.identicalFields;
  }

  // Position getters
  get positionsInBoth(): PositionMergeComparison[] {
    return WorkerWizardModule.positionsInBoth;
  }

  get positionsExistingOnly() {
    return WorkerWizardModule.positionsExistingOnly;
  }

  get positionsNewOnly() {
    return WorkerWizardModule.positionsNewOnly;
  }

  // Skills getters
  get skillsInBoth() {
    return WorkerWizardModule.skillsInBoth;
  }

  get skillsExistingOnly() {
    return WorkerWizardModule.skillsExistingOnly;
  }

  get skillsNewOnly() {
    return WorkerWizardModule.skillsNewOnly;
  }

  // Qualifications getters
  get qualificationsInBoth() {
    return WorkerWizardModule.qualificationsInBoth;
  }

  get qualificationsExistingOnly() {
    return WorkerWizardModule.qualificationsExistingOnly;
  }

  get qualificationsNewOnly() {
    return WorkerWizardModule.qualificationsNewOnly;
  }

  // Availability getters
  get availabilityInBoth() {
    return WorkerWizardModule.availabilityInBoth;
  }

  get availabilityExistingOnly() {
    return WorkerWizardModule.availabilityExistingOnly;
  }

  get availabilityNewOnly() {
    return WorkerWizardModule.availabilityNewOnly;
  }

  get hasAvailabilityData(): boolean {
    return this.availabilityInBoth.length > 0 ||
           this.availabilityExistingOnly.length > 0 ||
           this.availabilityNewOnly.length > 0;
  }

  get fieldsToUpdate(): number {
    return this.fieldsWithDifferences.filter(f => f.choice === 'new').length;
  }

  get positionsToDelete(): number {
    return this.positionsExistingOnly.filter(p => p.choice === 'delete').length;
  }

  get skillsToDelete(): number {
    return this.skillsExistingOnly.filter(s => s.choice === 'delete').length;
  }

  get qualificationsToDelete(): number {
    return this.qualificationsExistingOnly.filter(q => q.choice === 'delete').length;
  }

  get availabilityToDelete(): number {
    return this.availabilityExistingOnly.filter(a => a.choice === 'delete').length;
  }

  // Field choice setter
  setFieldChoice(field: string, choice: FieldChoice) {
    if (choice) {
      WorkerWizardModule.setFieldChoice({ field, choice });
    }
  }

  // Position field choice setter
  setPositionFieldChoice(positionId: string, field: keyof PositionFieldChoices, choice: FieldChoice) {
    if (choice) {
      WorkerWizardModule.setPositionFieldChoice({ positionId, field, choice });
    }
  }

  // Existing position choice setter
  setExistingPositionChoice(positionId: string, choice: KeepDeleteChoice) {
    if (choice) {
      WorkerWizardModule.setExistingPositionChoice({ positionId, choice });
    }
  }

  // Set existing skill choice
  setExistingSkillChoice(skillId: string, choice: KeepDeleteChoice) {
    if (choice) {
      WorkerWizardModule.setExistingSkillChoice({ skillId, choice });
    }
  }

  // Set existing qualification choice
  setExistingQualificationChoice(qualificationId: string, choice: KeepDeleteChoice) {
    if (choice) {
      WorkerWizardModule.setExistingQualificationChoice({ qualificationId, choice });
    }
  }

  // Set existing availability choice
  setExistingAvailabilityChoice(slot: string, choice: KeepDeleteChoice) {
    if (choice) {
      WorkerWizardModule.setExistingAvailabilityChoice({ slot, choice });
    }
  }

  // Set skill isVerified choice for skills that exist in both
  setSkillIsVerifiedChoice(skillId: string, choice: FieldChoice) {
    if (choice) {
      WorkerWizardModule.setSkillIsVerifiedChoice({ skillId, choice });
    }
  }

  // Set qualification isVerified choice for qualifications that exist in both
  setQualificationIsVerifiedChoice(qualificationId: string, choice: FieldChoice) {
    if (choice) {
      WorkerWizardModule.setQualificationIsVerifiedChoice({ qualificationId, choice });
    }
  }

  // Get position name safely
  getPositionName(position: any): string {
    if (position.position && position.position.name) {
      return position.position.name;
    }
    return position.positionId || 'Unknown Position';
  }

  // Get skill name safely
  getSkillName(skill: any): string {
    if (skill.skill && skill.skill.name) {
      return skill.skill.name;
    }
    return skill.skillId || 'Unknown Skill';
  }

  // Get qualification name safely
  getQualificationName(qualification: any): string {
    if (qualification.qualification && qualification.qualification.name) {
      return qualification.qualification.name;
    }
    return qualification.qualificationId || 'Unknown Qualification';
  }

  // Format currency
  formatCurrency(value: number): string {
    return CurrencyUtils.convertToCurrency(value);
  }

  // Strip HTML tags for plain text display
  stripHtml(html: string): string {
    if (!html) return '-';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const text = tmp.textContent || tmp.innerText || '';
    // Truncate for cell display
    const maxLength = 50;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  // Truncate summary for table display
  truncateSummary(text: string): string {
    if (!text) return '-';
    const maxLength = 100;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  // Check if a field is a boolean field that displays Yes/No
  isBooleanField(fieldName: string): boolean {
    // Note: isExactGeo displays "Exact"/"Approximate" so it's not included here
    const booleanFields = ['isDriver', 'isAgreedToMarketing', 'isUnspentConvictions'];
    return booleanFields.includes(fieldName);
  }

  // Check if workTypes array contains a specific work type
  hasWorkType(workTypes: any[] | undefined, type: string): boolean {
    if (!workTypes || !Array.isArray(workTypes)) return false;
    return workTypes.some(wt => wt === type || wt.toString() === type);
  }
}
